import React, { useEffect, useState } from "react";
import { useSwipeable } from "react-swipeable";
import { Icon, PlainButton, classnames } from "@culturehq/components";
import { mobileAndTabletCheck, t } from "app/utils";
import IconsPaginationSimple from "../IconsPaginationSimple";

const LightboxImageSlider = ({
  boxImages,
  onImageLoad,
  setImageSliderSwipe
}) => {
  const [currentImage, setCurrentImage] = useState(0);
  const quantity = boxImages?.length;
  const handlers = useSwipeable({
    onSwipedLeft: () => nextImage(true),
    onSwipedRight: () => previousImage(true),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const mobileHandlers = mobileAndTabletCheck() ? handlers : {};

  useEffect(
    () => {
      setCurrentImage(0);
    }, [boxImages]
  );

  if (!Array.isArray(boxImages) || quantity === 0) return <></>;

  const nextImage = (isSwipe = false) => {
    if (isSwipe && currentImage === quantity - 1) {
      setImageSliderSwipe(false);
    } else {
      setCurrentImage(currentImage === quantity - 1 ? 0 : currentImage + 1);
      setImageSliderSwipe(true);
    }
  };

  const previousImage = (isSwipe = false) => {
    if (isSwipe && currentImage === 0) {
      setImageSliderSwipe(false);
    } else {
      setCurrentImage(currentImage === 0 ? quantity - 1 : currentImage - 1);
      setImageSliderSwipe(true);
    }
  };

  const handleSliderChange = page => {
    setCurrentImage(page - 1);
  };

  return (
    <>
      <div className="container-lightbox" {...mobileHandlers}>
        {boxImages.map((image, index) => (
          <div
            key={index}
            className={classnames("chq-ffd--bg-img-container", "image-slider", currentImage === index ? "active" : undefined)}
          >
            <img
              className="gallery-lightbox__main-image gallery-lightbox__main-photo"
              src={image.url}
              onLoad={onImageLoad}
              alt={image.alt}
            />
          </div>
        ))}
        {boxImages.length > 1 && (
          <>
            <div>
              <PlainButton
                aria-label={t("Previous Image")}
                className="slider-arrow slider-arrow-left"
                onClick={previousImage}
              >
                <Icon icon="chevron-left" />
              </PlainButton>
            </div>
            <div>
              <PlainButton
                aria-label={t("Next Image")}
                className="slider-arrow slider-arrow-right"
                onClick={nextImage}
              >
                <Icon icon="chevron-right" />
              </PlainButton>
            </div>
            <div className="navigation-box">
              <IconsPaginationSimple
                currentPage={currentImage + 1}
                onClick={handleSliderChange}
                totalPages={boxImages.length}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default LightboxImageSlider;
